import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "mockyeah-devtools-extension",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#mockyeah-devtools-extension",
        "aria-label": "mockyeah devtools extension permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><code parentName="h1" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` DevTools Extension`}</h1>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` provides an extension for Chrome DevTools that provides a UI to create mocks to be used in the current page.`}</p>
    <p>{`You can create them based on Network entries or from scratch. You can edit mocks you've created.
Chrome will save them so they're still there if you close & re-open.`}</p>
    <p>{`The extension interacts with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`@mockyeah/fetch`}</code>{` on your web page,
so it looks for a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`window.__MOCKYEAH__`}</code>{` variable assigned to a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` instance
you create in your app source code (perhaps only development builds)
with the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`devTools`}</code>{` option enabled, as follows:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Mockyeah `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@mockyeah/fetch'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` mockyeah `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Mockyeah`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  devTools`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

window`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`__MOCKYEAH__ `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` mockyeah`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h2 {...{
      "id": "demo",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#demo",
        "aria-label": "demo permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Demo`}</h2>
    <p>{`Here's a GIF (wait for it to load) of the extension in use at `}<a parentName="p" {...{
        "href": "https://mockyeah-fetch-demo.netlify.com/"
      }}>{`https://mockyeah-fetch-demo.netlify.com/`}</a>{`:`}</p>
    <p><img parentName="p" {...{
        "src": "/f17d292d6121d13a73fe93c62647785e/demo.gif",
        "alt": "demo"
      }}></img></p>
    <h2 {...{
      "id": "install",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#install",
        "aria-label": "install permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Install`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Download `}<a parentName="p" {...{
            "href": "https://github.com/mockyeah/mockyeah/blob/master/packages/mockyeah-web-extension/mockyeah.crx?raw=true"
          }}>{`the `}<code parentName="a" {...{
              "className": "language-text"
            }}>{`.crx`}</code>{` file`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Extract it to a permanent location, e.g., `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`unzip mockyeah.crx -d mockyeah`}</code>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In Chrome, go to `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`Settings`}</code>{` (the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`⋮`}</code>{` icon in top-right corner) > `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`More Tools`}</code>{` > `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`Extensions`}</code></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Make sure `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`Developer mode`}</code>{` is enabled via the toggle at the top-right of the page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`Load unpacked`}</code>{` in the upper left and navigate to select the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`mockyeah`}</code>{` folder.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      